import { contractStatus } from '@/constants'

const mixin = {
  computed: {
    contractStatuses () {
      const statuses = []

      for (const prop in contractStatus) {
        const id = contractStatus[prop]
        let name, icon, color

        switch (id) {
          case contractStatus.new:
            name = this.$t('contractStatus.new')
            icon = 'mdi-circle-outline'
            color = 'pBlue'
            break
          case contractStatus.pendingSign:
            name = this.$t('contractStatus.pendingSign')
            icon = 'mdi-circle-outline'
            color = 'pBlue'
            break
          case contractStatus.sentForSign:
            name = this.$t('contractStatus.sentForSign')
            icon = 'mdi-circle-outline'
            color = 'pBlue'
            break
          case contractStatus.signed:
            name = this.$t('contractStatus.signed')
            icon = 'mdi-check-circle-outline'
            color = 'pGreen'
            break
          case contractStatus.cancelled:
            name = this.$t('contractStatus.cancelled')
            icon = 'mdi-close-circle-outline'
            color = 'pRed'
            break
          case contractStatus.rejected:
            name = this.$t('contractStatus.rejected')
            icon = 'mdi-close-circle-outline'
            color = 'pRed'
            break
        }

        statuses.push({
          id,
          name,
          icon,
          color
        })
      }
      return statuses
    }
  },


  methods: {
    getContractStatusById (statusId) {
      return this.contractStatuses.find(x => x.id === statusId)
    }
  }
}

export default mixin
